<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path id="Vector" d="M4.5038 7.3696C4.60051 7.2563 4.72013 7.16478 4.85479 7.10107C4.98944 7.03736 5.13607 7.00292 5.285 7H8.715C9.0398 7 9.3128 7.1652 9.4962 7.3696C9.68618 7.57952 9.79405 7.85094 9.8 8.134V8.358C9.8 9.5018 8.6562 10.5 7 10.5C5.3438 10.5 4.2 9.5018 4.2 8.358V8.134C4.2 7.8512 4.3218 7.574 4.5038 7.3696ZM7 5.6C7.3713 5.6 7.7274 5.4525 7.98995 5.18995C8.2525 4.9274 8.4 4.5713 8.4 4.2C8.4 3.8287 8.2525 3.4726 7.98995 3.21005C7.7274 2.9475 7.3713 2.8 7 2.8C6.6287 2.8 6.2726 2.9475 6.01005 3.21005C5.7475 3.4726 5.6 3.8287 5.6 4.2C5.6 4.5713 5.7475 4.9274 6.01005 5.18995C6.2726 5.4525 6.6287 5.6 7 5.6ZM7 14C8.85651 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85651 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85651 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85651 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM7 12.6C5.51479 12.6 4.09041 12.01 3.0402 10.9598C1.99 9.90959 1.4 8.48521 1.4 7C1.4 5.51479 1.99 4.09041 3.0402 3.0402C4.09041 1.99 5.51479 1.4 7 1.4C8.48521 1.4 9.90959 1.99 10.9598 3.0402C12.01 4.09041 12.6 5.51479 12.6 7C12.6 8.48521 12.01 9.90959 10.9598 10.9598C9.90959 12.01 8.48521 12.6 7 12.6Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'AccountIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '14',
    },
    viewBox: {
      type: String,
      default: '0 0 14 14',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
